












import { Component, Vue } from 'vue-property-decorator'
import Peer from 'peerjs'
import { Socket } from 'peerjs/lib/socket'
import { MyDataConnection } from '@/index'
import { GameModule } from './store'

@Component
export default class Chat extends Vue {
  $peer!: Peer & {
    on(
      event: 'connection',
      cb: (conn: MyDataConnection) => void
    ): void;
    socket: Socket;
  };

  browserSupported = true;
  get loading () {
    return GameModule.loading
  }
}
